module.exports = __webpack_public_path__ + "img/empty.f68cc916.png";